import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { IdleService } from './idle.service';
import { isPlatformBrowser } from '@angular/common';
import { merge } from 'rxjs/internal/observable/merge';
import { fromEvent } from 'rxjs/internal/observable/fromEvent';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class IdleConfigService {
  constructor(
    private idleService: IdleService,
    private sessionService: SessionService,
    @Inject(PLATFORM_ID) private platform
  ) {}

  configIdle() {
    if (isPlatformBrowser(this.platform)) {
      this.idleService.configIdle(
        merge(
          fromEvent(window, 'mousemove'),
          fromEvent(window, 'resize'),
          fromEvent(window, 'message'),
          fromEvent(document, 'keydown')
        )
      );

      this.idleService.onActivity.subscribe(() => {
        this.sessionService.refreshSession().subscribe(
          () => {},
          () => {
            console.error('Refresh token request failed');
          }
        );
      });
    }
  }
}
